//
// GENERATED by KVision
//
package pl.finn.forms.service

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import io.kvision.remote.RemoteOption
import pl.finn.forms.model.PostCodeList

actual class FormsService(requestFilter: (RequestInit.() -> Unit)? = null) : IFormsService, KVRemoteAgent<FormsService>(FormsServiceManager, requestFilter) {
    override suspend fun anuluj(token: String) = call(IFormsService::anuluj, token)
    override suspend fun getPostCodes(search: String?, initial: String?, state: String?) = call(IFormsService::getPostCodes, search, initial, state)
    override suspend fun getPostOffice(search: String?, initial: String?, state: String?) = call(IFormsService::getPostOffice, search, initial, state)
    override suspend fun getTowns(search: String?, initial: String?, state: String?) = call(IFormsService::getTowns, search, initial, state)
    override suspend fun getStreets(search: String?, initial: String?, state: String?) = call(IFormsService::getStreets, search, initial, state)
    override suspend fun terytKodPocztowySugAction(str: String?) = call(IFormsService::terytKodPocztowySugAction, str)
}
